// GA events handler
import triggerCustomGaEvent from '../utilities/analytics/triggerCustomGaEvent'

export const SET_RESTAURANTS = 'SET_RESTAURANTS'

export const setRestaurants = restaurants => ({
	type: SET_RESTAURANTS,
	payload: restaurants
})

export default function setRestaurantsData(restaurants) {
	return (dispatch) => {
		triggerCustomGaEvent('analytics-availableRestaurants', restaurants)

		dispatch(setRestaurants(restaurants))
	}
}


// WEBPACK FOOTER //
// ./src/actions/setRestaurants.js